import { Component, OnInit } from '@angular/core';
import { SessionService } from 'src/app/shared/_service/session.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { ProductService } from 'src/app/shared/_service/product.service';
import { AuthService } from 'src/app/auth/_service/auth.service';

// tslint:disable: max-line-length
@Component({
	selector: 'app-series',
	templateUrl: './series.component.html',
})
export class SeriesComponent implements OnInit {
	constructor(
		private session: SessionService,
		private router: Router,
		private route: ActivatedRoute,
		private productService: ProductService,
		private auth: AuthService,
	) {}

	idNeutral = environment.idNeutral;

	ordineCategorie = [
		{ nome: 'MC_P-CodLineaProdotto|05', ordine: 1 },
		{ nome: 'MC_P-CodLineaProdotto|15', ordine: 2 },
		{ nome: 'MC_P-CodLineaProdotto|10', ordine: 3 },
		{ nome: 'MC_P-CodLineaProdotto|80', ordine: 4 },
		{ nome: 'MC_P-CodLineaProdotto|25', ordine: 5 },
		{ nome: 'MC_P-CodLineaProdotto|45', ordine: 6 },
	];

	prodotti = [];
	prodottiVisualizzati = [];
	categorieVisualizzate = [];
	utente = this.auth.getUser();

	// Filtri visualizzati
	tipi = [];
	famiglie = [];
	colori = [];

	serie = '';
	showColors = false;

	ngOnInit() {
		this.route.queryParams.subscribe((params) => {
			this.prodotti = [];
			this.prodottiVisualizzati = [];
			this.categorieVisualizzate = [];
			this.tipi = [];
			this.famiglie = [];
			this.colori = [];
			this.serie = '';

			this.session.getProdotti().subscribe((prodotti) => {
				if (params.q) {
					const series: string[] = params.q.split(';');
					this.serie = series[0];

					// Scelgo se visualizzare il prodtto in base alla logica delle immagini:
					// 0 immagini -> Copio solo in professional e master se la categoria e' cappe, forni o piani, altrimenti in tutte e 3
					// 1 immagine -> Copio solo in professional e master se la categoria e' cappe, forni o piani, altrimenti in tutte e 3
					// 2 immagini -> Aggiungo solo se trovo la linea indicata dal campo lineaEstetica dell' oggetto immagine
					// 3 immagini -> Aggiungo solo se trovo la linea indicata dal campo lineaEstetica dell' oggetto immagine
					prodotti.forEach((prodotto) => {
						if (this.productService.isNeutral(prodotto)) {
							prodotto.isNeutral = true;
							prodotto.prodottiCommerciali.forEach((pc) => {
								// Caso 0 o 1 immagine -> Copio su tutte e 3 le serie solo se il prodotto é diverso da cappe, forni o piani
								// I prodotti neutral non devono essere copiati in cappe forni e piani
								if (pc.immagini.length === 1 || pc.immagini.length === 0) {
									if (!this.productService.condizioneCopiaNeutral(prodotto, this.serie)) {
										prodotto.prodottiCommerciali = [];
									}
								}
								// Caso 2 o 3 immagini -> Scelgo immagine giusta (1) e rimuovo se non trovo l'immagine corrispondente (2)
								if (pc.immagini.length >= 2) {
									const immagineDellaSerie = pc.immagini.find((immagine) => series.includes(immagine.lineaEstetica));
									pc.immagini = immagineDellaSerie ? [immagineDellaSerie] : []; // 1
									if (!immagineDellaSerie) {
										prodotto.prodottiCommerciali.splice(prodotto.prodottiCommerciali.indexOf(pc), 1); // 2
									}
								}
							});
						}
					});

					// Rimuovo i prodotti senza prodotti commerciali
					prodotti = prodotti.filter((p) => p.prodottiCommerciali.length > 0);
					this.prodotti = prodotti.filter((p) => series.includes(p.lineaEstetica) || p.isNeutral);
					this.prodotti.forEach((p) => {
						p.selected = p.prodottiCommerciali[0];
						p.prodottiCommerciali.forEach((pc) => (pc.quantita = 1));
					});
					this.prodotti.forEach(
						(p) => (p.prodottiCommerciali = p.prodottiCommerciali.sort((pc1, pc2) => (pc1.colore.ordine || 0) - (pc2.colore.ordine || 0))),
					);

					// Questo inserisce i filtri disponibili
					this.filtra();
				}
				console.log('Categorie Visualizzate:', this.categorieVisualizzate);
				console.log('Filtri:');
				console.log('Tipo:', this.tipi);
				console.log('Famiglia:', this.famiglie);
				console.log('Colore:', this.colori);
			});
		});
	}

	getDescrizione(prodotto) {
		return (
			prodotto.selected.descrizioni.find((d) => d.lingua.codice === 'US') || prodotto.descrizioni.find((d) => d.lingua.codice === 'US')
		);
	}

	stepQuantita(mode, prodottoCommerciale) {
		if (prodottoCommerciale) {
			if (prodottoCommerciale.quantita > 0 && mode === '-') {
				prodottoCommerciale.quantita--;
			}
			if (
				prodottoCommerciale.quantita < 100 &&
				mode === '+' &&
				!(prodottoCommerciale.statoGiacenza === 'IN_STOCK' && prodottoCommerciale.giacenza <= prodottoCommerciale.quantita)
			) {
				prodottoCommerciale.quantita++;
			}
		}
	}

	buy({ codiceTecnico, quantita }) {
		this.session.setCarrello(codiceTecnico, quantita, true).subscribe(() => this.router.navigate(['/cart']));
	}

	/* FILTRI */

	filtra(filtro?, value?) {
		if (filtro) {
			filtro.selected = value;
		}
		this.prodottiVisualizzati = this.prodotti;

		if (filtro && filtro.tipo === 'CATEGORY' && !value) {
			this.reset();
		}

		// Aggiorno i filtri visualizzati
		this.prodottiVisualizzati.forEach((p) => {
			if (!this.tipi.find((t) => t.valore === p.tipo)) {
				this.tipi.push({ valore: p.tipo, tipo: 'CATEGORY' });
			}
		});
		this.prodottiVisualizzati.forEach((p) => {
			if (!this.famiglie.find((f) => f.valore === p.famiglia)) {
				this.famiglie.push({ valore: p.famiglia });
			}
		});
		this.prodottiVisualizzati.forEach((p) =>
			p.prodottiCommerciali.forEach((pc) => {
				if (!this.colori.find((c) => c.valore === pc.colore.idBertazzoni)) {
					this.colori.push({ valore: pc.colore.idBertazzoni, codiceHtml: pc.colore.codiceHtml });
				}
			}),
		);
		this.colori = this.colori.sort((c1, c2) => (c1.ordine || 0) - (c2.ordine || 0));

		// Filtro i prodotti per tipo
		const tipiDeselezionati = this.tipi.filter((f) => !f.selected);
		if (tipiDeselezionati.length < this.tipi.length) {
			tipiDeselezionati.forEach(({ valore }) => (this.prodottiVisualizzati = this.prodottiVisualizzati.filter((p) => p.tipo !== valore)));
		}

		// Filtro i prodotti per famiglia
		const famiglieDeselezionati = this.famiglie.filter((f) => !f.selected);
		if (famiglieDeselezionati.length < this.famiglie.length) {
			famiglieDeselezionati.forEach(
				({ valore }) => (this.prodottiVisualizzati = this.prodottiVisualizzati.filter((p) => p.famiglia !== valore)),
			);
		}

		// Filtro i prodotti per colore
		const coloriSelezionati = this.colori.filter((c) => c.selected);
		if (coloriSelezionati.length > 0) {
			let prodottiVisualizzatiPreFiltroColore = this.prodottiVisualizzati;
			this.prodottiVisualizzati = [];
			coloriSelezionati.forEach(({ valore }) => {
				// Cerco i prodotti con quel colore
				const prodottiConColore = prodottiVisualizzatiPreFiltroColore.filter((p) =>
					p.prodottiCommerciali.find((pc) => pc.colore.idBertazzoni === valore),
				);
				// Tolgo dai prodotti da filtrare quelli che sto per aggiungere
				prodottiVisualizzatiPreFiltroColore = prodottiVisualizzatiPreFiltroColore.filter((x) => !prodottiConColore.includes(x));
				this.prodottiVisualizzati = this.prodottiVisualizzati.concat(prodottiConColore);
			});
		}

		// Riabilito tutti i filtri
		this.tipi.forEach((t) => (t.disabled = false));
		this.famiglie.forEach((f) => (f.disabled = false));
		this.colori.forEach((f) => (f.disabled = false));

		// Disabilito i filtri che non producono risultati
		this.tipi.forEach((t) => {
			if (!this.prodottiVisualizzati.find((p) => p.tipo === t.valore)) {
				t.disabled = true;
			}
		});
		this.famiglie.forEach((f) => {
			if (!this.prodottiVisualizzati.find((p) => p.famiglia === f.valore)) {
				f.disabled = true;
			}
		});
		this.colori.forEach((f) => {
			if (!this.prodottiVisualizzati.find((p) => p.prodottiCommerciali.find((pc) => pc.colore.idBertazzoni === f.valore))) {
				f.disabled = true;
			}
		});

		// Popolo le categorie
		this.categorieVisualizzate = [];
		this.tipi
			.filter((t) => !t.disabled)
			.forEach((t) => {
				this.categorieVisualizzate.push({ nome: t.valore, prodotti: this.prodottiVisualizzati.filter((p) => p.tipo === t.valore) });
			});

		this.ordinaCategorie();
	}

	reset() {
		this.tipi.forEach((t) => {
			t.selected = false;
		});
		this.famiglie.forEach((f) => {
			f.selected = false;
		});
		this.colori.forEach((c) => {
			c.selected = false;
		});
		this.showColors = false;
		this.filtra();
	}

	ordinaCategorie() {
		this.categorieVisualizzate = this.categorieVisualizzate.sort((c1, c2) => {
			const c1ordine = this.ordineCategorie.find((x) => x.nome === c1.nome);
			const c2ordine = this.ordineCategorie.find((x) => x.nome === c2.nome);
			if (c1ordine && c2ordine) {
				return c1ordine.ordine - c2ordine.ordine;
			}
			return 0;
		});

		this.categorieVisualizzate.forEach((c) => {
			c.prodotti = c.prodotti.sort((p1, p2) =>
				p2.prodottiCommerciali[0].codiceCommerciale.localeCompare(p1.prodottiCommerciali[0].codiceCommerciale),
			);
		});

		this.tipi = this.tipi.sort((t1, t2) => {
			const t1ordine = this.ordineCategorie.find((x) => x.nome === t1.valore);
			const t2ordine = this.ordineCategorie.find((x) => x.nome === t2.valore);
			if (t1ordine && t2ordine) {
				return t1ordine.ordine - t2ordine.ordine;
			}
			return 0;
		});
	}

	isNew(prodotto) {
		const date = moment(prodotto.dataCreazione, 'dd/MM/yyyy');
		return moment().diff(date, 'months', true) < 3;
	}

	get tipoSelezionato() {
		return this.tipi.find((t) => t.selected);
	}

}
